export const resetPassword = {
    title: 'パスワードを再入力',
    newPassword: '新しいパスワード',
    confirmNewPassword: '新しいパスワードを再入力',
    resetSuccess: 'パスワードの再設定が成功しました',
    buttonSave: '保存',
};
